module.exports = __webpack_public_path__ + "static/parkison-dfd42dedc22d519b280f6e8a7d7ed034.png";